import { dateToString } from "./date-util";

enum LogLevel {
  none = 0,
  info,
  warn,
  error,
}

class Logger {
  constructor(private readonly logLevel: LogLevel) {}

  private log(logLevel: LogLevel, message: string): void {
    if (logLevel > this.logLevel) return;
    const printedMessage = `[${dateToString()}] ${LogLevel[logLevel]
      .toString()
      .toUpperCase()}`;
    switch (logLevel) {
      case LogLevel.info:
        console.info(printedMessage, message);
        break;
      case LogLevel.warn:
        console.warn(printedMessage, message);
        break;
      case LogLevel.error:
        console.error(printedMessage, message);
        break;
      default:
        break;
    }
  }

  public info(message: string): void {
    this.log(LogLevel.info, message);
  }

  public warn(message: string): void {
    this.log(LogLevel.warn, message);
  }

  public error(message: string): void {
    this.log(LogLevel.error, message);
  }
}

export const logger = new Logger(LogLevel.error);
